<template>
  <div class="account-hub">
    <div class="hub-master">
    <!-- Nav bar：僅返回鍵 -->
    <div class="hub-navbar">
      <a class="back-btn" href="#" @click.prevent="goBack">
        <Icon name="chevron-left" size="24" />
      </a>
    </div>

    <div class="hub-scroll">
      <!-- 個人資料區塊 -->
      <div class="profile-block" v-if="memberData">
        <div class="profile-avatar">
          <img :src="userPicUrl" alt="avatar" />
        </div>
        <div class="profile-info">
          <div class="user-id fs-14px" v-if="memberData.publicId && memberData.publicId.length > 0">@{{ memberData.publicId }}</div>
          <div class="user-name fs-h2" v-text="memberData.displayName"></div>
          <div class="user-share fs-14px">
            <div>
              <span class="fw-bold" v-text="clothCount"></span>
              <span> 件公開衣物</span>
            </div>
            <div>|</div>
            <div>
              <span class="fw-bold" v-text="outfitCount"></span>
              <span> 則穿搭分享</span>
            </div>
          </div>
        </div>
      </div>

      <!-- 兩顆按鈕（先放 UI，不接行為） -->
      <div class="quick-btns">
        <button type="button" class="quick-btn" @click="onBrandSizeClicked">
          <Icon name="brand-size" size="24" />
          <span class="fs-16px fw-bold">我的品牌尺寸</span>
        </button>
        <button type="button" class="quick-btn" @click="onBodyDataClicked">
          <Icon name="body-data" size="24" />
          <span class="fs-16px fw-bold">我的身體數據</span>
        </button>
      </div>

      <!-- 選單 -->
      <div class="settings-group">
        <div class="settings-item fs-16px fw-bold" @click.prevent="showWcPointManage">
          <span>織點</span>
          <div class="item-right">
            <span class="point-badge fs-14px">{{ wcPoint }}點</span>
            <Icon name="chevron-right" size="24" />
          </div>
        </div>
        <div class="settings-item fs-16px fw-bold" @click.prevent="showRedeemCode">
          <span>兌換碼</span>
          <Icon name="chevron-right" size="24" />
        </div>
        <div class="settings-item fs-16px fw-bold" @click.prevent="showAiStudio">
          <span>AI 工作室</span>
          <Icon name="chevron-right" size="24" />
        </div>
        <div class="settings-item fs-16px fw-bold" @click.prevent="openGroup('personal')">
          <span>個人資訊設定</span>
          <Icon name="chevron-right" size="24" />
        </div>
        <div class="settings-item fs-16px fw-bold" @click.prevent="goToPublicPage">
          <span>公開頁面</span>
          <Icon name="chevron-right" size="24" />
        </div>
        <div class="settings-item fs-16px fw-bold" @click.prevent="openGroup('consign')">
          <span>寄售相關</span>
          <Icon name="chevron-right" size="24" />
        </div>
        <div class="settings-item fs-16px fw-bold" @click.prevent="openGroup('about')">
          <span>關於長腳衣櫥</span>
          <Icon name="chevron-right" size="24" />
        </div>
      </div>

      <div class="logout-btn fs-16px" @click="logoutClicked">登出</div>
    </div>
    </div><!-- /hub-master -->

    <!-- 桌機 detail 區占位（手機隱藏；開啟子頁/葉節點 modal 時會覆蓋在其上） -->
    <div class="hub-detail-area">
      <div class="detail-placeholder fs-14px">請從左側選擇項目</div>
    </div>

    <!-- 子頁：個人資訊設定 -->
    <transition name="slide">
      <FullScreenModal v-if="openedGroup === 'personal'" class="account-noback" title="個人資訊設定" @back="closeGroup">
        <div class="settings-group">
          <div class="settings-item fs-16px fw-bold" @click.prevent="showAccountSecurity">
            <span>會員帳號設定</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="showPersonalInfo">
            <span>會員資訊</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="showProfileEdit">
            <span>編輯個人檔案</span>
            <Icon name="chevron-right" size="24" />
          </div>
        </div>
      </FullScreenModal>
    </transition>

    <!-- 子頁：寄售相關 -->
    <transition name="slide">
      <FullScreenModal v-if="openedGroup === 'consign'" class="account-noback" title="寄售相關" @back="closeGroup">
        <div class="settings-group">
          <div class="settings-item fs-16px fw-bold" @click.prevent="showBankAccountManage">
            <span>收款銀行帳戶設定</span>
            <Icon name="chevron-right" size="24" />
          </div>
        </div>
      </FullScreenModal>
    </transition>

    <!-- 子頁：關於長腳衣櫥 -->
    <transition name="slide">
      <FullScreenModal v-if="openedGroup === 'about'" class="account-noback" title="關於長腳衣櫥" @back="closeGroup">
        <div class="settings-group">
          <div class="settings-item fs-16px fw-bold" @click.prevent="showBuyFlow">
            <span>購物流程</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="showExchange">
            <span>退換貨政策</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="showUpdateHistory">
            <span>版本更新歷史</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="showPolicy">
            <span>隱私權聲明</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="goToAbout">
            <span>關於我們</span>
            <Icon name="chevron-right" size="24" />
          </div>
          <div class="settings-item fs-16px fw-bold" @click.prevent="shareApp">
            <span>分享 App</span>
            <Icon name="chevron-right" size="24" />
          </div>
        </div>
      </FullScreenModal>
    </transition>

    <!-- 公開頁面（桌機顯示在右側 detail） -->
    <transition name="slide">
      <FullScreenModal v-if="showPublicPage" class="account-public-page" title="公開頁面" @back="showPublicPage = false">
        <UserPage :serial="loginUserSerial" />
      </FullScreenModal>
    </transition>

    <transition name="fade">
      <WcCommonModal v-if="isLogoutModalShow" @cancel="isLogoutModalShow = false" @ok="logout" hide-header>
        <div class="text-center" style="font-size: 14px;">
          確定登出?
        </div>
      </WcCommonModal>
    </transition>
  </div>
</template>

<script>
import { mapGetters, mapActions, mapState } from 'vuex';
import FullScreenModal from '@/components/FullScreenModal.vue';
import WcCommonModal from '@/components/commons/WcCommonModal.vue';
import UserPage from '@/views/share/UserPage.vue';
import NoPicUser from '@/assets/userPage/no-pic-user.png';

export default {
  name: 'AccountHub',
  components: {
    FullScreenModal,
    WcCommonModal,
    UserPage,
  },
  data() {
    return {
      openedGroup: null, // 'personal' | 'consign' | 'about'
      showPublicPage: false, // 桌機：公開頁面顯示在右側 detail
      isLogoutModalShow: false,
    };
  },
  computed: {
    ...mapState(['user']),
    ...mapGetters(['loginUserSerial']),
    memberData() {
      return this.$store.state.memberData.memberData;
    },
    userPicUrl() {
      return (this.memberData && this.memberData.picUrl) || NoPicUser;
    },
    clothCount() {
      return this.memberData && this.memberData.cloths ? this.memberData.cloths.length : 0;
    },
    outfitCount() {
      return this.memberData && this.memberData.outfits ? this.memberData.outfits.length : 0;
    },
    wcPoint() {
      return this.user.wcPoint;
    },
  },
  async mounted() {
    await this.$store.dispatch('memberData/refreshUserData');
  },
  beforeDestroy() {
    // 離開帳號中心時關閉殘留的 detail modal，避免在其他頁面以全屏置中殘留
    this.closeAllDetails();
    this.openedGroup = null;
  },
  methods: {
    ...mapActions([
      'showMsgModal',
      'setAccountSecurityShow',
      'setPersonalInfoShow',
      'setProfileEditShow',
      'setBodyConfigShow',
      'setBodyConfigInitialTab',
      'setBankAccountManageShow',
      'setBuyFlowShow',
      'setExchangeShow',
      'setPolicyShow',
      'setChangelogShow',
      'setWcPointManageShow',
      'setAiStudioShow',
    ]),
    ...mapActions('redeem', ['openRedeemModal', 'closeRedeemModal']),

    // 關閉所有由本頁開出的 detail modal（桌機 master-detail 下避免彼此堆疊互相遮擋）
    closeAllDetails() {
      this.showPublicPage = false;
      this.setAccountSecurityShow(false);
      this.setPersonalInfoShow(false);
      this.setProfileEditShow(false);
      this.setBodyConfigShow(false);
      this.setBankAccountManageShow(false);
      this.setBuyFlowShow(false);
      this.setExchangeShow(false);
      this.setPolicyShow(false);
      this.setChangelogShow(false);
      this.setWcPointManageShow(false);
      this.setAiStudioShow(false);
      this.closeRedeemModal();
    },

    goBack() {
      if (!this.$router) {
        return;
      }

      if (this.$router.hasPreviousRoute) {
        this.$router.back();
      } else {
        this.$router.push({ name: 'Home' });
      }
    },
    openGroup(group) {
      this.closeAllDetails();
      this.openedGroup = group;
    },
    closeGroup() {
      this.openedGroup = null;
    },

    // 上方兩顆按鈕：都進「我的身體數據」頁，分別開對應分頁
    onBrandSizeClicked() {
      this.closeAllDetails();
      this.openedGroup = null;
      this.setBodyConfigInitialTab('brand');
      this.setBodyConfigShow(true);
    },
    onBodyDataClicked() {
      this.closeAllDetails();
      this.openedGroup = null;
      this.setBodyConfigInitialTab('body');
      this.setBodyConfigShow(true);
    },

    // 第一層
    showWcPointManage() {
      this.closeAllDetails();
      this.openedGroup = null;
      this.setWcPointManageShow(true);
    },
    showRedeemCode() {
      this.closeAllDetails();
      this.openedGroup = null;
      this.openRedeemModal();
    },
    showAiStudio() {
      this.closeAllDetails();
      this.openedGroup = null;
      this.setAiStudioShow(true);
    },
    goToPublicPage() {
      // 桌機：顯示在右側 detail；手機：維持整頁導向公開頁
      if (window.matchMedia('(min-width: 992px)').matches) {
        this.closeAllDetails();
        this.openedGroup = null;
        this.showPublicPage = true;
      } else {
        this.$router.push({ name: 'UserPublic', params: { serial: this.loginUserSerial } });
      }
    },

    // 個人資訊設定（保留所屬群組清單，僅關閉其他 detail，讓返回可回到子清單）
    showAccountSecurity() {
      this.closeAllDetails();
      this.setAccountSecurityShow(true);
    },
    showPersonalInfo() {
      this.closeAllDetails();
      this.setPersonalInfoShow(true);
    },
    showProfileEdit() {
      this.closeAllDetails();
      this.setProfileEditShow(true);
    },

    // 寄售相關
    showBankAccountManage() {
      this.closeAllDetails();
      this.setBankAccountManageShow(true);
    },

    // 關於長腳衣櫥
    showBuyFlow() {
      this.closeAllDetails();
      this.setBuyFlowShow(true);
    },
    showExchange() {
      this.closeAllDetails();
      this.setExchangeShow(true);
    },
    showUpdateHistory() {
      this.closeAllDetails();
      this.setChangelogShow(true);
    },
    showPolicy() {
      this.closeAllDetails();
      this.setPolicyShow(true);
    },
    goToAbout() {
      window.open('https://www.walkingcloset.co/about', '_blank');
    },
    shareApp() {
      if (window.navigator.share) {
        window.navigator.share({
          title: '長腳衣櫥',
          text: '推薦你「長腳衣櫥」！一個讓衣物管理更智慧、衣物不浪費的秘密基地。一起加入吧！',
          url: 'https://walkingcloset.network/closet/',
        }).then(() => {
          console.log('成功！');
        }).catch((error) => {
          console.log('發生錯誤', error);
        });
      } else {
        this.copyMsg('https://walkingcloset.network/closet/');
        this.showMsgModal('已複製連結!');
      }
    },
    copyMsg(msg) {
      const node = document.createElement('span');
      node.innerText = msg;
      node.setAttribute('style', 'position:absolute;left:0;top:0;opacity:0;');
      document.body.appendChild(node);
      const selection = window.getSelection();
      selection.removeAllRanges();
      const range = document.createRange();
      range.selectNode(node);
      selection.addRange(range);
      try {
        document.execCommand('copy');
      } catch (err) {
        console.error(err);
      }
      selection.removeAllRanges();
      node.remove();
    },

    // 登出
    logoutClicked() {
      this.isLogoutModalShow = true;
    },
    logout() {
      this.isLogoutModalShow = false;
      this.$store.dispatch('logout');
      this.$router.push({ name: 'Login' });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";

.account-hub {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
  background: $color-white;

  // 手機：master 佔滿，detail 占位區隱藏
  .hub-master {
    display: flex;
    flex-direction: column;
    flex: 1 1 auto;
    min-height: 0;
  }
  .hub-detail-area {
    display: none;
  }

  .hub-navbar {
    flex: 0 0 auto;
    height: 52px;
    display: flex;
    align-items: center;
    padding: 0 .25rem;
    .back-btn {
      width: 44px;
      height: 44px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: $typography-primary-default;
    }
  }

  .hub-scroll {
    position: relative;
    flex: 1 1 auto;
    overflow-y: auto;
    padding-bottom: 2rem;
  }

  .profile-block {
    display: flex;
    align-items: center;
    gap: 1.25rem;
    padding: 1.25rem 1.5rem;
    .profile-avatar {
      flex: 0 0 94px;
      width: 94px;
      height: 94px;
      border-radius: 50%;
      overflow: hidden;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }
    .profile-info {
      display: flex;
      flex-direction: column;
      gap: .25rem;
      min-width: 0;
      .user-id {
        color: $typography-secondary-default;
      }
      .user-name.fs-h2 {
        margin-bottom: 0;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      .user-share {
        display: flex;
        align-items: center;
        gap: .5rem;
        flex-wrap: nowrap;
      }
    }
  }

  .quick-btns {
    display: flex;
    gap: 1.25rem;
    padding: 1.25rem 1.5rem;
    background: $color-gray-light;
    .quick-btn {
      flex: 1 1 0;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: .625rem;
      padding: .75rem;
      background: $color-white;
      border: 1px solid $color-border;
      border-radius: 12px;
      color: $typography-primary-default;
      cursor: pointer;
    }
  }

  .settings-group {
    display: flex;
    flex-direction: column;
    .settings-item {
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: .5px solid $color-border;
      padding: 1rem 1.5rem;
      .item-right {
        display: flex;
        align-items: center;
        gap: .5rem;
      }
      .point-badge {
        padding: .125rem .5rem;
        border-radius: 999px;
        background: $color-orange-light;
        color: $typography-primary-default;
        font-weight: normal;
      }
    }
  }

  .logout-btn {
    cursor: pointer;
    color: $typography-primary-error;
    padding: 1.5rem;
  }

  // 桌機：左側 320px master + 右側 detail 占位區（子頁/葉節點 modal 會由 MainApp 定位覆蓋在右側）
  @include bigger-than-large {
    flex-direction: row;

    .hub-master {
      flex: 0 0 320px;
      width: 320px;
      background: #FAFAFA;
      box-shadow: 1px 0 0 0 $color-border;
    }

    // 頭像獨立一列：頭像在上，資訊置中於下方
    .profile-block {
      flex-direction: column;
      align-items: center;
      text-align: center;
      gap: .75rem;
      .profile-info {
        align-items: center;
      }
      .user-share {
        justify-content: center;
      }
    }

    .hub-detail-area {
      display: flex;
      flex: 1 1 auto;
      align-items: center;
      justify-content: center;
      .detail-placeholder {
        color: $typography-secondary-default;
      }
    }

    // 兩顆按鈕在窄欄改為直向堆疊
    .quick-btns {
      flex-direction: column;
    }
  }
}

/* 子頁滑入動畫 */
.slide-enter-active, .slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter, .slide-leave-to {
  transform: translateX(100%);
}
</style>
